import { useCallback, useEffect, useState } from 'react';
import { getSubscriptionHealth, type SubscriptionHealthData } from '../api/admin';

export function useSubscriptionHealth() {
  const [data, setData]       = useState<SubscriptionHealthData | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getSubscriptionHealth();
      setData(res.data.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => setData(null));
  }, [refresh]);

  return { data, loading, refresh };
}
